import { AfterViewInit, DestroyRef, Directive, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[verificationCode]'
})
export class VerificationCodeDirective implements AfterViewInit{

  private ngControl = inject(NgControl);
  private destroyRef = inject(DestroyRef);

  constructor() { }

  ngAfterViewInit(): void {
    this.ngControl.valueChanges
      ?.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: string) => {
        let initialValue =
          typeof value === 'string' ? value.replace(/[^0-9]/g, '') : '';

          if(initialValue.length > 6) {
            initialValue = initialValue.substring(0, 6);
          }
        if (value !== initialValue) {
          this.ngControl.control?.setValue(initialValue, { emitEvent: false });
        }
      });
  }


}
